<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-form-embed v-if="showModal === 'embed'" />
            <v-modal-form-preview v-if="showModal === 'preview'" />
        </transition>

        <v-page-header icon="fas fa-pen-to-square">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'forms' }">Forms</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="form.name" :title="form.name" @saved="updateFormName" editable />
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-identifier v-if="form" :uuid="form.id" />
            <v-button-toolbar>
                <v-button size="sm" btn-style="secondary" @click.native="$store.commit('showModal', 'preview')">Preview Form</v-button>
                <v-button size="sm" @click.native="$store.commit('showModal', 'embed')">Embed Form</v-button>
            </v-button-toolbar>
        </v-page-filters>

        <v-page-body>
            <v-step-elements :step="1" />
            <v-step-colors :step="2" />
            <v-step-settings :step="3" />
        </v-page-body>

    </v-page>

</template>

<script>

import FormApi from '@api/FormApi';
import ModalFormEmbed from '@modals/form/ModalFormEmbed';
import ModalFormPreview from '@modals/form/ModalFormPreview';
import StepColors from './components/StepColors';
import StepElements from './components/StepElements';
import StepSettings from './components/StepSettings';

export default {

    components: {
        'v-modal-form-embed': ModalFormEmbed,
        'v-modal-form-preview': ModalFormPreview,
        'v-step-colors': StepColors,
        'v-step-elements': StepElements,
        'v-step-settings': StepSettings,
    },

    data() {
        return {
            loading: false,
        }
    },

    created() {
        this.$store.commit('form/reset');
    },

    mounted() {
        this.getForm();
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

    },

    methods: {

        getForm() {
            this.$store.commit('loading', true);
            FormApi.getForm(this.$route.params.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('form/setForm', response.data.data)
                    this.$events.$emit('pageLoaded');
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        updateFormName(name) {
            this.$store.commit('loading', true);
            FormApi.updateFormName(this.form.id, name)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        previewForm() {
            this.$store.commit('showModal', 'preview');
        },

    }

}

</script>